export const shortVenueSummary = (
    city: string | null,
    region: string | null,
    country: string | null
): string =>
    [city, region, country].filter( x => x !== null).join(', ')